module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIKADAAQAAAABAAAAGAAAAAA915G0AAAAp0lEQVRIDWN01pktzszMvIeBgUEHiHECm6T/OOWwSShX5mIThosxMjBcYWBkdGEixnK4LioygN7RYfj/fw+jm/48sNcUhEPwGt+/jROvPLrkB1UldCEU/oG3b8F8JhTRAeCMOmA0BEZDYDQERkNgNARGQ2A0BEZDgAXYCrsCxDoP3q7B2yDrnUliqxja5sNrKAPDeaa/f/+6AI2+RkAhLaTPMzIyegIAltUhJ+fgIpsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flag-fr@2x.png
// module id = 517
// module chunks = 9